import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { NAV } from "@/constants/testIds";

const links = [
  { id: "services", label: "Services", testid: NAV.linkServices },
  { id: "about", label: "About", testid: NAV.linkAbout },
  { id: "projects", label: "Projects", testid: NAV.linkProjects },
  { id: "contact", label: "Contact", testid: NAV.linkContact },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid={NAV.root}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-[#E5E5E5]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <button
          data-testid={NAV.logo}
          onClick={() => scrollTo("top")}
          className="flex items-baseline gap-2 group"
          aria-label="Vertex Elevators home"
        >
          <span className="font-display font-black text-xl md:text-2xl tracking-tighter">
            VERTEX
          </span>
          <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#FF5E00]">
            Elevators
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => scrollTo(l.id)}
              className="vx-link text-[11px] font-bold uppercase tracking-[0.22em] text-[#0A0A0A] hover:text-[#FF5E00] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <a
          data-testid={NAV.ctaEmergency}
          href="tel:+14374940799"
          className="hidden md:inline-flex items-center gap-2 bg-[#FF5E00] hover:bg-[#E05200] text-white px-5 py-3 text-[11px] font-bold uppercase tracking-[0.22em] transition-transform hover:-translate-y-0.5"
        >
          <Phone size={14} strokeWidth={2.5} />
          24/7 Emergency
        </a>

        <button
          data-testid={NAV.menuToggle}
          className="md:hidden p-2 border border-[#0A0A0A]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-[#E5E5E5]">
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`${l.testid}-mobile`}
                onClick={() => scrollTo(l.id)}
                className="text-left text-sm font-bold uppercase tracking-[0.22em] py-2 border-b border-[#E5E5E5]"
              >
                {l.label}
              </button>
            ))}
            <a
              href="tel:+14374940799"
              className="mt-2 inline-flex items-center justify-center gap-2 bg-[#FF5E00] text-white px-5 py-3 text-xs font-bold uppercase tracking-[0.22em]"
            >
              <Phone size={14} /> 24/7 Emergency Line
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
